import { schema } from "normalizr";
import { arrayOfAttachments } from "~/schemas/schema.attachments";

const calendarEvent = new schema.Entity(
  "calendarEvents",
  {},
  {
    processStrategy: (entity) => {
      if (entity.participants && entity.participants.length > 0) {
        const participants = entity.participants.map((p) => p.user_email);
        return {
          ...entity,
          participants: participants,
        };
      }
      return entity;
    },
  }
);

calendarEvent.define({
  attachments: arrayOfAttachments,
});

const arrayOfCalendarEvents = [calendarEvent];

export { calendarEvent, arrayOfCalendarEvents };
